<template>
  <td>
    
      <!-- {{dataItem.taxExpiryDate}} -->
    <div  v-bind:class="getClass(dataItem.maintenanceDueDate)">
      {{ cellFunction(dataItem.maintenanceDueDate)}}
    </div>
  </td>
</template>

<script>
import moment from "moment-timezone";
export default {
  props: {
    dataItem: Object,
    columnIndex: Number,
  },
  methods: {
    changeHandler: function(event) {
      this.item.status = event.value;
      this.$emit("change", { dataItem: this.item });
    },
    getClass(val){
    
       if(new Date(val) < new Date()){
           return "invalid"
       }
       return "valid"
    
    },
    cellFunction(val){
      if(val){
        return val=moment(val).format("DD/MM/YYYY")
      }
      return "" 
    }
  },

  data: function() {
    return {
      item: { ...this.dataItem },
    };
  },
};
</script>

<style>
.invalid {
 color: #f90e0e
}
</style>
